import React from 'react';
import styles from './BoardFourA.module.css';

const BoardFourA = ({ apiData }) => {
    // Destructure necessary fields from apiData for clarity
    const {
        salesPrice,
        salesTax,
        mvaFee,
        docFee,
        downpayment,
    } = apiData.deal;

    // Convert string values to numbers
    const salesPriceNum = Number(salesPrice) || 0;
    const salesTaxNum = Number(salesTax) || 0;
    const mvaFeeNum = Number(mvaFee) || 0;
    const docFeeNum = Number(docFee) || 0;
    const downpaymentNum = Number(downpayment) || 0;

    // Calculate total and base financed amount dynamically
    const total = salesPriceNum + salesTaxNum + mvaFeeNum + docFeeNum;
    const baseFinancedAmount = total - downpaymentNum;

    return (
        <div className={styles.board}>
            <h2 className={styles.title}>New Finance</h2>
            <hr className={styles.divider} />
            <div className={styles.boardContainer}>
                <div className={styles.item}>
                    <div className={styles.label}>Sale Price:</div>
                    <div className={styles.value}>${salesPriceNum.toFixed(2)}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>Sales Tax:</div>
                    <div className={styles.value}>${salesTaxNum.toFixed(2)}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>MVA Fees:</div>
                    <div className={styles.value}>${mvaFeeNum.toFixed(2)}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>Doc Fee:</div>
                    <div className={styles.value}>${docFeeNum.toFixed(2)}</div>
                </div>

                <hr className={styles.divider} />

                <div className={styles.total}>
                    <div className={styles.label}>Total:</div>
                    <div className={styles.value}>${total.toFixed(2)}</div>
                </div>

                <div className={styles.item}>
                    <div className={styles.label}>Down Payment:</div>
                    <div className={styles.value}>-${downpaymentNum.toFixed(2)}</div>
                </div>

                <div className={styles.baseAmount}>
                    <div className={styles.label}>Base Financed Amount:</div>
                    <div className={styles.value}>${baseFinancedAmount.toFixed(2)}</div>
                </div>
            </div>
        </div>
    );
};

export default BoardFourA;
